import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import { useSidebarPinState } from '@backstage/core-components';

const UserSettingsPinToggle = () => {
  const { isPinned, toggleSidebarPinState } = useSidebarPinState();
  return /* @__PURE__ */ React.createElement(ListItem, null, /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: "Pin Sidebar",
      secondary: "Prevent the sidebar from collapsing"
    }
  ), /* @__PURE__ */ React.createElement(ListItemSecondaryAction, null, /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      placement: "top",
      arrow: true,
      title: `${isPinned ? "Unpin" : "Pin"} Sidebar`
    },
    /* @__PURE__ */ React.createElement(
      Switch,
      {
        color: "primary",
        checked: isPinned,
        onChange: () => toggleSidebarPinState(),
        name: "pin",
        inputProps: { "aria-label": "Pin Sidebar Switch" }
      }
    )
  )));
};

export { UserSettingsPinToggle };
//# sourceMappingURL=UserSettingsPinToggle.esm.js.map
